'use client';
import { createContext, useContext, RefObject, createRef } from 'react';

const scrollableRef = createRef<HTMLDivElement>();
const TargetScrollableContext = createContext<RefObject<HTMLDivElement>>(scrollableRef);

export const TargetScrollableProvider = ({
	children
}: {
	children: React.ReactNode
}) => {
	return (
		<TargetScrollableContext.Provider value={scrollableRef}>
			{children}
		</TargetScrollableContext.Provider>
	);
}

export const useTargetScrollableContext = () => useContext(TargetScrollableContext);





